import axios from 'axios';

const axiosInstance = axios.create({
    // baseURL: 'http://82.156.174.212:8005/api/', // 统一配置基础 URL
    // baseURL: 'http://47.92.156.237:8007/api/', // 统一配置基础 URL
    // baseURL: 'https://my.zuhaoguanjia.com/api/', // 统一配置基础 URL
    // baseURL: 'https://v2.zuhaoguanjia.com/api/', // 统一配置基础 URL
    baseURL: process.env.VUE_APP_API_BASE_URL,

    withCredentials: true,
    responseType: 'blob' // 需要设置响应类型为blob，以便处理图片文件
});

// 请求拦截器
axiosInstance.interceptors.request.use(
    config => {
        const captchaUuid = localStorage.getItem('captchaUuid')
        config.headers['x-captcha-uuid'] = `${captchaUuid}`;
        
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
    response => {

        const captchaUuid = response.headers['x-captcha-uuid']
        if (captchaUuid) {
            localStorage.setItem('captchaUuid', captchaUuid);
        }
        // 如果包含authorization
        const newToken = response.headers['Authorization'];
        if (newToken) {
            localStorage.setItem('access_token', newToken);
        }
        return response;
    },
    error => {
        return Promise.reject(error);
    }
);

// ===== 图形验证码 并发去重 (同一source在飞期间共享一个响应, 消除"图/UUID对不上→填对也判错"竞态, 同时压并发) =====
try {
    const _inflight = new Map();
    const _base = axios.getAdapter(axios.defaults.adapter);
    if (typeof _base === 'function') {
        axiosInstance.defaults.adapter = (config) => {
            const url = config.url || '';
            if (url.indexOf('get_image_captcha') === -1) return _base(config);
            const src = (url.match(/source=([^&]*)/) || [])[1] || 'default';
            const key = 'cap:' + src;
            if (_inflight.has(key)) return _inflight.get(key);
            const p = Promise.resolve(_base(config))
                .then((res) => { _inflight.delete(key); return res; })
                .catch((e) => { _inflight.delete(key); throw e; });
            _inflight.set(key, p);
            return p;
        };
    }
} catch (e) {
    console.warn('captcha dedup init skipped:', e);
}

export default axiosInstance;